import React, { useEffect } from 'react';
import SEO from '../components/Seo';
import LocalBusinessSchema from '../components/LocalBusinessSchema';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Marquee from '../components/Marquee';
import LatestProjects from '../components/LatestProjects';
import Portfolio from '../components/Portfolio';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';

function Home() {
  // Track page view for analytics (optional)
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'GA_MEASUREMENT_ID', {
        page_path: '/'
      });
    }
  }, []);

  return (
    <>
      <SEO />
      <LocalBusinessSchema />
      
      {/* Add h1 tag for main heading */}
      <div style={{ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden' }}>
        <h1>Faheem Graphics - Professional Graphic Design Services</h1>
      </div>
      
      <Hero />
      <About />
      <Services />
      <Marquee />
      <LatestProjects />
      <Portfolio />
      <Reviews />
      <Contact />
    </>
  );
}

export default Home;